import { render } from "./FloorHole.vue?vue&type=template&id=297d1fe8&scoped=true"
import script from "./FloorHole.vue?vue&type=script&lang=js"
export * from "./FloorHole.vue?vue&type=script&lang=js"

import "./FloorHole.vue?vue&type=style&index=0&id=297d1fe8&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-297d1fe8"]])

export default __exports__